import { render, staticRenderFns } from "./workTask.vue?vue&type=template&id=31a0b786&"
import script from "./workTask.vue?vue&type=script&lang=js&"
export * from "./workTask.vue?vue&type=script&lang=js&"
import style0 from "./workTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports